const cn = (state = "", action) => {
    switch (action.type) {
        case "CHANGE_CITY":
            return state = action.payload;

        default:
            return state;
    }
}
export default cn;